"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, core_1.createStyles)({
        root: {
            display: 'flex',
            width: 50,
            flexShrink: 0,
            height: '100%',
            overflow: 'hidden',
            cursor: 'pointer',
            zIndex: 1,
            transition: '0.2s',
            flexDirection: 'column',
            '&$disabled': {
                opacity: 0,
                width: 0,
                marginLeft: 0,
                marginRight: 0,
                cursor: 'auto',
                zIndex: -1,
            },
            marginTop: 1,
            marginRight: -20,
            alignItems: 'flex-start',
            '&$rightArrow': {
                marginLeft: -20,
                alignItems: 'flex-end',
            },
        },
        arrow: {
            transform: 'rotate(90deg)',
            '&$rightArrow': {
                transform: 'rotate(-90deg)',
            },
        },
        arrowWhiteVariant: {
            backgroundColor: 'white',
            borderRadius: '50%',
            border: theme_1.default.borders.primary,
            padding: 4,
        },
        rightArrow: {},
        disabled: {},
    });
});
